export const LINKEDIN_URL = 'https://www.linkedin.com/company/tsbuddy/'
